import moment from 'moment-timezone'
import momentFormatTime from 'moment'

import numeral from 'numeral'
import * as CONST from '../../Reducers/PickupTimes/const'
import { MOCK_PHONE_NUMBER } from '../../shared/constants'

export const currencyFormatter = (value, options, customCurrency = '') => {
  const opts = options || {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }

  const number = new Intl.NumberFormat('en-US', opts)
  return `${customCurrency ? customCurrency : ''}${number.format(value)}`
}

export const numberFormatter = (value, format = '0,0') =>
  numeral(value).format(format)

/**
 * Formats a number with 2 dp if there's any decimals, if there isn't any decimal
 * values then it ommits them
 * @param {number} value
 * @return {string}
 */
export const numberFormatterWithOptional2Dp = (
  value,
  enforceDecimals = false,
) => {
  var decimal = Number(value).toFixed(2)
  if (enforceDecimals === false && decimal.endsWith('.00'))
    return decimal.slice(0, -3)
  return decimal
}

/**
 * Round a number to 2 dp
 * @param {number} value
 * @returns {number}
 */
export const round2Dp = value => {
  return Math.round(value * 100) / 100
}

export function dateFormatter(value, dateFormat, timezone = null) {
  return value && moment(value).format(dateFormat)
}

export function percentageFormatter(value) {
  return value && `${value}%`
}

export const timeFormatter = value =>
  value
    ? moment()
        .hours(value.split(':')[0])
        .minutes(value.split(':')[1])
        .toDate()
    : value

/**
 * Makes a number more readable
 * From here https://stackoverflow.com/a/2901298/837649
 * @param {number} num
 */
export const numberWithCommas = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * Make a phone number more readable
 * @param {string} phoneNumber
 * @returns {string}
 */
export const formatPhoneNumber = phoneNumber => {
  if (!phoneNumber) return ''

  if (phoneNumber === MOCK_PHONE_NUMBER) {
    return 'Phone number to be provided'
  }

  phoneNumber += ''

  var suffixes = []
  while (phoneNumber.length > 3 && suffixes.length < 2) {
    suffixes.push(phoneNumber.slice(-3))
    phoneNumber = phoneNumber.slice(0, -3)
  }

  while (suffixes.length > 0) {
    var s = suffixes.pop()
    phoneNumber += ' ' + s
  }
  return phoneNumber
}

/**
 * Checks if value is defined and if not returns a default '-'
 * @param {*} value
 * @returns {*}
 */

export const formatFieldValue = value => {
  if (value === null || value === undefined) {
    return '-'
  }
  return value
}

/**
 * Convert the visual target cost per metric string to the numeric value.
 * The visual value is in dollars where the numeric value is in cents
 * @param {string} str
 * @returns {number|null}
 */
export function convertMonetaryDollarStringToCentValue(str) {
  if (str === '') return null
  var val = Number(str)
  if (isNaN(val)) return null
  return val * 100
}

/**
 * Convert the real target cost per metric value to the string representation
 * which is dollars whereas the real value is cents.
 * @param {number} val
 * @returns {string}
 */
export function convertCentValueToMonetaryString(val) {
  if (val == null || val == undefined) return null
  return val / 100 + ''
}

export function roundingAfterDecimalPoint(type, num, currentRound) {
  return +(Math[type](num + `e+${currentRound}`) + `e-${currentRound}`)
}
/**
 * Format time to the following 24h format
 * @param timeString
 */
export const format24Time = timeString => {
  return momentFormatTime(
    timeString,
    CONST.TIME_FORMATS.HOURS_MINUTES_SECONDS,
  ).format(CONST.TIME_FORMATS.HOURS_MINUTES)
}

export const formatStringToFirstUpperCase = string => {
  const lowerCase = string.toLowerCase()
  return lowerCase[0].toUpperCase() + lowerCase.slice(1)
}
